<template>
    <div v-if="loading" id="loading" class="text-center my-5">
        <div class="custom-spinner pull-center mt-2"></div>
    </div>
</template>
<script>
export default {
    props: ["loading"]
}
</script>